import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: theme.spacing(1.25),
  },
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingRight: theme.spacing(1),
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingTop: theme.spacing(2),
}));

export const SubtitleText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
  fontSize: "0.9375rem",
  fontWeight: 500,
  color: theme.palette.grey[700],
}));

export const InstructionText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: "0.8125rem",
  color: theme.palette.grey[600],
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  fontSize: "0.8125rem",
  color: theme.palette.error.main,
}));

export const FieldsStack = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const FieldRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
}));

export const CheckboxCell = styled(Box)({
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
});

export const PlaceholderAsValue = styled("span")(({ theme }) => ({
  color: theme.palette.grey[500],
}));

export const BulkFieldTextField = styled(TextField)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  "& .MuiOutlinedInput-root": {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[300],
  },
  "& .MuiInputBase-input": {
    color: theme.palette.text.primary,
  },
  "& .MuiInputBase-input::placeholder": {
    color: theme.palette.grey[500],
    opacity: 1,
  },
  "& .Mui-disabled .MuiInputBase-input::placeholder": {
    color: theme.palette.action.disabled,
    opacity: 1,
  },
  "& .MuiSelect-select": {
    display: "flex",
    alignItems: "center",
    minHeight: "1.25em",
  },
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  justifyContent: "flex-end",
  gap: theme.spacing(1),
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  textTransform: "none",
  fontWeight: 500,
}));

export const ApplyButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  fontWeight: 600,
  borderRadius: theme.spacing(1),
  paddingLeft: theme.spacing(2.5),
  paddingRight: theme.spacing(2.5),
}));
